export const DEEP_LINK_URL_LENGTH_MIN = 3;
export const DEEP_LINK_URL_LENGTH_MAX = 8192;
export const DEEP_LINK_LIST_LENGTH_MAX = 10;

export enum ClientMessageType {
    OPEN_DEEP_LINKS = "OpenDeepLinks",
}

export const ClientMessageCookieNames = {
    WSW_DEEP_LINKS: "wsw-deep-links",
};
